import { BUY_PRO_URL, PRICING_DETAILS_URL } from "@/utils/constants";
import { Button } from "./button";
import { css } from "@/utils/css";
import { __ } from "@wordpress/i18n";
import { FaCrown } from "react-icons/fa";
import { useModal } from "@/hooks/use-modal";
import logo from "@/assets/img/logo.webp";

type Props = {
    title?: string;
    message?: string;
};

export function ProAlertBox({
    title = __("This is a Premium Feature", "antimanual"),
    message = __("Upgrade to unlock this feature and access all premium capabilities.", "antimanual"),
}: Props) {
    const handleUpgrade = () => {
        window.open(BUY_PRO_URL, "_parent");
    };

    return (
        <div
            style={{
                textAlign: "center",
                padding: "40px 24px",
                width: 450,
            }}
        >
            <div
                style={{
                    width: "60px",
                    height: "60px",
                    background: "#0080ff1e",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto 24px",
                    padding: 8,
                    position: "relative",
                }}
            >
                <img src={logo} alt="Antimanual" style={{ width: "100%" }} />
                <FaCrown style={{ position: "absolute", top: -24, left: 0, right: 0, margin: "0 auto", fontSize: "36px", color: "#ffae00" }} />
            </div>

            <h2
                className={css("modal-title")}
                style={{
                    fontSize: "24px",
                    fontWeight: "600",
                    marginBottom: "12px",
                    color: "#1e293b",
                }}
            >
                {title}
            </h2>

            <p
                style={{
                    fontSize: "15px",
                    color: "#64748b",
                    marginBottom: "32px",
                    lineHeight: "1.6",
                }}
            >
                {message}
            </p>

            <Button
                variant="primary"
                className={css("w-full")}
                onClick={handleUpgrade}
                style={{
                    background: "linear-gradient(90deg, #0079FF, #0DB9F2)",
                    border: "none",
                    fontSize: "16px",
                    fontWeight: "600",
                    padding: "12px 24px",
                    marginBottom: "12px",
                }}
            >
                {__("Upgrade to Pro", "antimanual")}
            </Button>

            <p
                style={{
                    fontSize: "13px",
                    color: "#94a3b8",
                    margin: "0",
                }}
            >
                <a href={PRICING_DETAILS_URL} target="_blank" className={css("link")}>
                    {__("Learn more", "antimanual")}
                </a>{" "}
                {__("about premium features", "antimanual")}
            </p>
        </div>
    );
}

export function useProModal() {
    const { openModal } = useModal();

    return {
        showProAlert: (title?: string, message?: string) => openModal(<ProAlertBox title={title} message={message} />),
    };
}

export function SimpleProAlert({ children }: React.PropsWithChildren) {
    return <span className={css("text-orange")}>{children || __("Monthly Limit Exceeded", "antimanual")}</span>;
}
